import { Form, Select } from "antd";

import { useOpportunities } from "../../data/use-opportunities";
import { filterOption } from "./filter-option";
import { pickFormItemProps, pickSelectProps } from "./pick-props";
import { getSelectOptions } from "../../utils/get-select-options";

export const OpportunitySelect = (props) => {
  const opportunities = useOpportunities();

  const form = Form.useFormInstance();
  const initialValue = form.getFieldValue(props.name);

  return (
    <Form.Item {...pickFormItemProps(props)}>
      <Select
        showSearch
        optionFilterProp="children"
        filterOption={filterOption}
        options={getSelectOptions({
          store: opportunities,
          initialIds: initialValue,
          filter: props.filter,
          labelKey: "alias",
        })}
        {...pickSelectProps(props)}
      />
    </Form.Item>
  );
};
